import { Button } from '@mui/material';
import { useEditLocation } from './hooks';
import { EditLocationModal } from './EditLocationModal';

interface ILocationProfileProps {
  patient_id: string;
  disabled: boolean;
}

export const EditLocation = ({
  patient_id,
  disabled = false,
}: ILocationProfileProps) => {
  const { handleClose, handleOnClick, isOpen } = useEditLocation();

  return (
    <>
      <Button
        disabled={disabled}
        onClick={handleOnClick}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          minWidth: 'unset',
        }}
      >
        EDIT
      </Button>
      {isOpen && !disabled && (
        <EditLocationModal
          isOpen
          patient_id={patient_id}
          handleClose={handleClose}
        />
      )}
    </>
  );
};
